const Form049TC = {
    stepName: {
        statement: "重要事項",
        application: "申請詳情",
        confirmation: "確認",
    },
    errorMsg: {
        date: {
            afterThisDate: "請選擇入職本校日期之後的日期",
        },
        needOne: "必須填寫“幼稚園名稱”或“幼兒中心名稱”",
        leastOneNo: "請最少填寫一個編號",
    },
    serial: ["(a)", "(b)", "(c)", "(d)", "(e)", "(f)", "(g)", "(h)"],
    noteTitle1: "<u>收集個人資料的目的</u>",
    noteTitle3: "<u>可獲轉移資料者</u>",
    noteTitle4: "<u>查閱個人資料</u>",
    notes: [
        "你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：",
        "你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理。",
        "你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：",
        "你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向以下人士提出：香港太古城太古灣道14號6樓602室幼稚園及幼兒中心聯合辦事處當值主任或電郵至 <a href='mailto:jokc@edb.gov.hk'>jokc@edb.gov.hk</a>。",
    ],
    notes1: [
        "就<b>幼稚園暨幼兒中心職員變動</b>，辦理有關處理、核實及查證的事務；",
        "就上文(a)項所述的處理、核實及查證，辦理有關把<b>個人資料</b>與政府相關政策局／部門資料庫<b>進行核對程序</b>的事務；",
        "為核實／更新教育局的記錄，辦理有關把<b>個人資料</b>與教育局資料庫<b>進行核對程序</b>的事務；",
        "辦理有關<b>培訓及發展</b>的事務，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
        "辦理有關處理及審核<b>撥款／補助／津貼</b>申請、發放<b>撥款／補助／津貼</b>，以及審計的事務；",
        "辦理有關編製<b>統計資料、研究材料</b>及<b>政府刊物</b>的事務；以及",
        "辦理有關<b>施行及強制執行規則及規例</b> [包括《教育條例》（香港法例第279章）及其附屬法例（例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》）和《資助則例》）]的事務；及《幼兒服務條例》（香港法例第243章）及其附屬法例 [即《幼兒服務規例》（香港法例第243A章）]的事務",
    ],
    notes3: [
        "政府其他政策局及部門，以用於上文第1段所述的用途；",
        "與本表格相關的學校，以用於上文第1段所述的用途；",
        "你曾就披露個人資料給予訂明同意；以及",
        "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
    ],
    label: {
        note: "重要事項",
        p_title: "個人資料收集聲明",
        basicInfor: "幼稚園及幼兒中心名稱",
        noteItemOne:
            "根據《教育條例》第三十九條第（二）款，凡校長停止執行校長的職責或任何教員開始或停止在學校任教，",
        boldTextOne: "校監",
        noteItemTwo: "須於變更後",
        boldTextTwo: "一個月內",
        noteItemThree:
            "以書面通知教育局常任秘書長。而根據《幼兒服務規例》第七條第（二）款，凡主管／幼兒工作員出現變動，",
        boldTextThree: "經營人／主管",
        noteItemFour: "須於變更後",
        boldTextFour: "十四天內",
        noteItemSix: "以書面通知社會福利署署長。",
        statement: "聲明",
        certify: "本人已閱讀、明白及同意上述條款及細則。",
        smart: "本人理解申請人和學校審批人需要擁有「智方便+」帳戶才能處理申請。",
        kindergarten: "幼稚園名稱",
        childCareName: "幼兒中心名稱",
        nameEnglish: "教師／幼兒工作員姓名（英文）",
        nameChinese: "教師／幼兒工作員姓名（中文）",
        qualification: "資歷",
        rtNo: "檢定教員註冊編號",
        validPTNo: "有效准用教員編號",
        progress: "申請中",
        cCCSNo: "幼兒中心主管註冊編號",
        cCCWNo: "幼兒工作員註冊編號",
        workingHours: "工作時間",
        firstDate: "入職本校日期",
        position: "已離職",
        lastDate: "最後任職日期",
        responsible: "任職班別",
        training: "曾接受急救訓練",
        certificateNo: "有效急救訓練證書編號（如適用）",
        effectiveDate: "急救訓練證書編號生效日期",
        expiryDate: "急救訓練證書編號到期日期",
        submit: "我想提交這個申請表",
        attachment: "附件上傳",
        rtptNo: "檢定教員註冊編號／有效准用教員編號",
        cCCNo: "幼兒中心主管註冊編號／幼兒工作員註冊編號",
        registrationCert: "附件",
        firstAidCert: "有效急救證書",
        attachmentTitle:
            "除已呈交者外，請呈交所有教員證、幼兒工作員證及有效急救證書的核實副本存檔",
        supervisorName: "校監姓名",
    },
    no: {
        rtNo: "R",
        validPTNo: "P",
    },
    cCCNo: {
        cCCSNo: "CCC/S",
        cCCWNo: "CCC/W",
    },
    noteValue: {
        note1: "「BEd(ECE)」：持有幼兒教育學士學位或同等學歷的合格幼稚園教師／幼兒工作員",
        note2: "「C(ECE)」：持有幼兒教育證書或同等學歷的合格幼稚園教師／幼兒工作員",
        note3: "「QKT」：合格幼稚園教師",
        note4: "「CCW」：幼兒工作員",
        note5: "「Pursuing C(ECE)」：正在修讀幼兒教育證書或同等學歷的課程的合格幼稚園教師／幼兒工作員／持有檢定教員註冊編號／有效准用教員編號的敎師",
    },
    workingHoursValue: {
        "AM+PM": "上午+下午",
        AM: "上午",
        PM: "下午",
    },
    whetherValue: {
        Y: "是",
        N: "否",
    },
    qualificationValue: {
        "BEd(ECE)": "BEd(ECE)",
        "C(ECE)": "C(ECE)",
        QKT: "QKT",
        CCW: "CCW",
        "Pursuing C(ECE)": "Pursuing C(ECE)",
    },
    responsibleValue: {
        kg: "幼稚園",
        ccc: "幼兒中心",
    },
};
export default Form049TC;
